import { Lightning, Coins, CurrencyDollar, UsersThree } from "@phosphor-icons/react";
import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, SectionHeader } from "./primitives";

const ICONS = [Lightning, Coins, CurrencyDollar, UsersThree];

const WhyJovino = () => {
  const config = useSiteConfig();
  return (
    <section id="about" className="relative py-24 lg:py-36" data-testid="why-jovino-section">
      <div className="section-shell">
        <SectionHeader
          index={1}
          eyebrow="Why Jovino Coin"
          title={<>The challenges JCV<br className="hidden sm:block" /> is built to address</>}
          sub="Jovino Coin is a fixed-supply, utility-focused digital asset designed to power a growing decentralized ecosystem — with transparency, security, sustainability and long-term development at its core."
          testId="why-jovino-header"
        />
        <div className="mt-14 grid gap-5 md:grid-cols-2">
          {config.problems.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={p.title} delay={i * 0.08} testId={`problem-card-${i}`}>
                <article className="card-surface group relative h-full rounded-xl p-8 lg:p-10 overflow-hidden">
                  <div className="absolute -right-6 -top-6 font-mono text-[90px] font-bold text-line/50 leading-none select-none" aria-hidden="true">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <Icon size={30} className="text-teal transition-transform duration-300 group-hover:scale-110" aria-hidden="true" />
                  <h3 className="mt-6 font-display text-xl lg:text-2xl font-semibold text-mist">{p.title}</h3>
                  <p className="mt-3 text-sm lg:text-base text-slate leading-relaxed max-w-md">{p.body}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.2} className="mt-16 text-center">
          <p className="font-display font-bold tracking-tight text-2xl sm:text-4xl lg:text-5xl" data-testid="why-jovino-closer">
            <span className="text-gold">Fixed Supply.</span>{" "}
            <span className="text-teal">Real Utility.</span>{" "}
            <span className="text-mist">Community Governance.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default WhyJovino;
